import React from 'react'
import { Filter, FilterComponent } from '../../components/_WMS/FilterComponent'
import { filterOptions } from './config'

export interface FilterOption {
  order: number
  key: string
  label: string
  type: 'numeric' | 'text' | 'range' | 'precreated' | 'custom' | 'date'
  options?: []
  Component?: React.ComponentType<ComponentProps>
}

interface ComponentProps {}
interface ProductSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
}

export const ProcessSearch: React.FC<ProductSearchProps> = (props) => {
  return (
    <FilterComponent
      options={filterOptions}
      {...props}
    />
  )
}
